var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame29(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.233597,
    y: 0.233597,
    width: 86.7413,
    height: 86.7412
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.38px)",
      clipPath: "url(#bgblur_0_1661_1020_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1661_1020)",
    "data-figma-bg-blur-radius": 8.7664
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042,
    fill: "#35FF71",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1252 50.179C36.121 50.6302 34.8378 51.3234 34.8378 52.1007C34.8378 53.4602 38.7626 54.5622 43.6042 54.5622C48.4457 54.5622 52.3706 53.4602 52.3706 52.1007C52.3706 51.3234 51.0873 50.6302 49.0832 50.179",
    stroke: "#35FF71",
    strokeWidth: 1.6437,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3437 40.3168C46.3437 41.8298 45.1172 43.0563 43.6042 43.0563C42.0913 43.0563 40.8647 41.8298 40.8647 40.3168C40.8647 38.8038 42.0913 37.5773 43.6042 37.5773C45.1172 37.5773 46.3437 38.8038 46.3437 40.3168Z",
    stroke: "#35FF71",
    strokeWidth: 1.6437
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9821 49.6241C44.6124 49.9801 44.1185 50.179 43.6044 50.179C43.0903 50.179 42.5963 49.9801 42.2267 49.6241C38.8422 46.3446 34.3065 42.681 36.5184 37.3623C37.7144 34.4864 40.5852 32.6462 43.6044 32.6462C46.6236 32.6462 49.4943 34.4865 50.6903 37.3623C52.8994 42.6743 48.3749 46.3559 44.9821 49.6241Z",
    stroke: "#35FF71",
    strokeWidth: 1.6437
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1661_1020",
    x: 0.233597,
    y: 0.233597,
    width: 86.7413,
    height: 86.7412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.26121,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1661_1020"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.453826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1661_1020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1661_1020",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.907652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.71504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1661_1020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1661_1020_clip_path",
    transform: "translate(-0.233597 -0.233597)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 69.2084,
    height: 69.2084,
    rx: 34.6042
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame29);
export default __webpack_public_path__ + "static/media/Frame 29.46adb79ecddcd16507adee98ad87cec7.svg";
export { ForwardRef as ReactComponent };